export const LEGAL_URLS = {
  privacyNotice: 'https://www.zillow.com/corporate/zg-privacy-notice/',
  termsOfUse: 'https://www.zillow.com/corporate/terms-of-use/',
} as const;
